<template>
  <div
    class="image"
  >
    <div
      v-if="!loaded"
      class="spinner"
    />
    <!-- Wrapper -->
    <div
      v-if="loaded"
      class="image__wrapper"
    >
      <picture>
        <source
          media="--small"
          :data-srcset="mobileImageId"
        >

        <source
          media="--large"
          :data-srcset="imageId"
        >
        <img
          class="lazyload"
          data-sizes="auto"
          :data-src="imageId"
        >
      </picture>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ImageSimple',

  props: {
    imageId: {
      type: String,
      required: false,
      default: ''
    },

    mobileImageId: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      loaded: false
    };
  },

  mounted() {
    this.loaded = true;
  }
};
</script>

<style lang="scss" src="@/assets/components/image/image-simple.scss"></style>
<style lang="scss" src="@/assets/components/loader/spinner.scss"></style>



// WEBPACK FOOTER //
// image-simple.vue